import React from "react";

import { AHButton, Card, SectionHeader } from "arkh";
import { FormattedMessage, useIntl } from "react-intl";
import { useRoutineEditStateSetParams } from "../../State/RoutineEditState";

export function RoutineEditScheduleCardNoSchedule() {
  const intl = useIntl();

  const setParams = useRoutineEditStateSetParams();
  return (
    <>
      <SectionHeader>
        <SectionHeader.Title>
          <FormattedMessage
            defaultMessage="Schedule"
            description="Routine Admin Edit Overview Schedule Title"
          />
        </SectionHeader.Title>
      </SectionHeader>
      <Card>
        <AHButton
          themeType="primary"
          title={intl.formatMessage({
            defaultMessage: "Add schedule",
            description: "RoutineEditScheduleCard empty schedule cta title",
          })}
          onPress={() => {
            setParams({
              scheduleFreq: "daily",
              scheduleDaily: {
                freq: "daily",
                isAllDay: false,
                deadlineDuration: null,
                weekdays: Array(7)
                  .fill(0)
                  .map((_, i) => ({
                    weekday: i,
                    startTime: { hour: 12, minute: 0 },
                    originalTaskImportance: {},
                    taskImportanceChanges: {},
                  })),
              },
            });
          }}
        />
      </Card>
    </>
  );
}
